import type { User } from '@/api/auth';
import { ContentTypes } from '@/helpers/api';
import { CLIENT_BASE_URL } from '@/modules/api/helpers';
import { sendOtherSignOutWithoutClickEvent } from '@/modules/googleAnalytics/events/otherEvents';
import { isClient } from '@/modules/server/helpers-client';

const SKIP_URLS = new Set(['users', 'users/sign_in', 'users/sign_out']);
const COOKIE_CHANGED_HEADER = 'x-cookie-changed';

export function resetSignOutTracked(): void {
  if (!isClient()) return;
  window.signOutTracked = false;
}

export async function handleSignOutEvent(
  url: string,
  headers: Headers
): Promise<void> {
  if (!isClient()) return;

  if (SKIP_URLS.has(url) || headers.get(COOKIE_CHANGED_HEADER) !== 'true') {
    return;
  }

  try {
    // Direct fetch to avoid recursion with fetcherSS.
    const response = await fetch(`${CLIENT_BASE_URL}/player`, {
      method: 'GET',
      headers: {
        'Content-Type': ContentTypes.jsonDefault,
        Accept: ContentTypes.vndJson,
      },
      credentials: 'include',
    });
    if (!response.ok) return;

    const text = await response.text();
    if (!text) return;

    const user = JSON.parse(text) as User;

    if (user?.id != null) return;

    if (window.signOutTracked) return;
    window.signOutTracked = true;
    sendOtherSignOutWithoutClickEvent();
  } catch (error) {
    console.log('[handleSignOutEvent] error:', error);
  }
}
